import styled from 'styled-components';

export const CloseButtonModal = styled.button<{top: number, right: number}>`
  position: absolute;
  top: ${({ top }) => `${top}px`};
  right: ${({ right }) => `${right}px`};
`;
